<template>
  <div class="data-slider">
    <div class="data-slider__header">
      <h3 v-if="packet.dataCounter !== null">
        <span class="bolder" :class="styleColor">{{ packetCurrent }} </span>
        <span class="bolder">/ {{ packetMax }} </span>
        <span
          class="smaller data-slider__header--normal"
          v-t="'general.gigabytes'"
        ></span>
      </h3>
      <h3 v-else>
        <span class="bolder" :class="styleColor"
          >{{ packet.durationCounter.days }}
        </span>
        <span class="bolder">/ {{ packet.durationCounter.maxDays }} </span>
        <span
          class="smaller data-slider__header--normal"
          v-t="'general.days_short'"
        ></span>
      </h3>
    </div>
    <div class="data-slider__status">
      <span
        :style="style"
        class="data-slider__status--tooltip min"
        v-t="'general.now'"
      ></span>
    </div>
    <div class="data-slider__bar"></div>
    <div class="data-slider__duration" v-if="packet.dataCounter !== null">
      <p class="data-slider__duration--start min">
        {{ packetMax }} <span v-t="'general.gigabytes'"></span>
      </p>
      <p class="data-slider__duration--end min">
        0 <span v-t="'general.gigabytes'"></span>
      </p>
    </div>
    <div class="data-slider__duration" v-else>
      <i18n
        tag="p"
        path="frontpage.packetStarts"
        class="data-slider__duration--start min"
        ><span place="date">{{ packetStart }}</span></i18n
      >
      <i18n
        tag="p"
        path="frontpage.packetEnds"
        class="data-slider__duration--end min"
        ><span place="date">{{ packetEnd }}</span></i18n
      >
    </div>
    <div class="data-slider__expires" v-if="packet.dataCounter !== null">
      <i18n tag="p" class="smaller" path="frontpage.validUntil">
        <span place="date">{{ packetEnd }}</span>
      </i18n>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
export default {
  props: {
    packet: {
      type: Object,
    },
  },
  computed: {
    packetStart() {
      return moment(this.packet.durationCounter.start).format('D.M.YYYY');
    },
    packetEnd() {
      return moment(this.packet.durationCounter.end).format('D.M.YYYY');
    },
    packetMax() {
      return this.packet.dataCounter.max / Math.pow(1024, 3);
    },
    packetCurrent() {
      return (
        Math.round(
          (this.packet.dataCounter.remaining / Math.pow(1024, 3)) * 100
        ) / 100
      );
    },
    style() {
      return {
        right: `${this.pos_percentage}`,
      };
    },
    pos_percentage() {
      if (this.packet.dataCounter) {
        return `${(this.packet.dataCounter.remaining /
          this.packet.dataCounter.max) *
          100}%`;
      } else {
        return `${(this.packet.durationCounter.days /
          this.packet.durationCounter.maxDays) *
          100}%`;
      }
    },
    styleColor() {
      let perc = 0;

      if (this.packet.dataCounter) {
        perc = this.packet.dataCounter.remaining / this.packet.dataCounter.max;
      } else {
        perc =
          this.packet.durationCounter.days /
          this.packet.durationCounter.maxDays;
      }

      return {
        'color--100': perc > 0.8,
        'color--80': perc <= 0.8 && perc > 0.6,
        'color--60': perc <= 0.6 && perc > 0.55,
        'color--50': perc <= 0.55 && perc > 0.45,
        'color--40': perc <= 0.45 && perc > 0.2,
        'color--20': perc <= 0.2 && perc > 0.1,
        'color--0': perc < 0.1,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
$color-white: #fff;
$color-black: #000;
$color-midblack: #121212;
$color-slategray: #4b5055;

$color-green: #00b201;
$color-red: #e80c0c;
$color-orange: #ff7800;

$color-100: $color-green;
$color-80: #18ad01;
$color-60: #7d9c00;
$color-50: #a69500;
$color-40: #e88300;
$color-20: #ff6901;
$color-0: $color-red;

.data-slider {
  position: relative;
  width: 100%;
  padding: 0 0 10px;

  h3,
  p {
    margin: 0;
  }

  .color {
    &--100 {
      color: $color-100;
    }
    &--80 {
      color: $color-80;
    }
    &--60 {
      color: $color-60;
    }
    &--50 {
      color: $color-50;
    }
    &--40 {
      color: $color-40;
    }
    &--20 {
      color: $color-20;
    }
    &--0 {
      color: $color-0;
    }
  }

  &__header {
    padding: 0 0 20px;

    &--normal {
      font-weight: 400;
    }
  }

  &__duration {
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    &--start,
    &--end {
      margin: 0;
    }
  }

  &__status {
    position: relative;
    width: 100%;
    height: 22.5px;
    &--tooltip {
      position: absolute;
      top: 0;
      right: 0;
      height: 20px;
      padding: 0 5px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      background-color: $color-midblack;
      color: $color-white;
      transform: translateX(50%);

      span {
        margin: 0;
        text-align: center;
      }

      &:after {
        content: '';
        position: absolute;
        bottom: -5px;
        left: 50%;
        transform: translateX(-50%);
        width: 0;
        height: 0;
        border-left: 5px solid transparent;
        border-right: 5px solid transparent;
        border-top: 5px solid $color-midblack;
      }
    }
  }

  &__bar {
    width: 100%;
    height: 5px;
    background-image: linear-gradient(
      to right,
      $color-green 0%,
      $color-orange 75%,
      $color-red 100%
    );
    margin-top: 2.5px;
  }
}
</style>
